module.exports = __webpack_public_path__ + "img/QR-4999.a8691b10.png";